






import { Component, Vue } from 'vue-property-decorator';
import EventCalendar from '@/components/Calendar/EventCalendar.vue';

@Component({
  components: {
    EventCalendar,
  },
})
export default class Calendar extends Vue {

}
